import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {Message} from '../../shared/models/message';
import {MessageService} from '../../shared/services/message.service';
import {Subscription} from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-message',

  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit, AfterViewChecked, OnChanges {

  messages: Message[];
  message: Message = new Message();
  imgUrl = environment.imgUrl;   
  busy: Subscription;


  constructor(private messageService: MessageService, private changeDetectorRef: ChangeDetectorRef,
              private spinner: NgxSpinnerService) {
  }

  @Input() submission_id: string;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  ngOnInit() {
    console.log(this.submission_id);
    this.getAllMessages(this.submission_id);


  }

  ngOnChanges() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {
    }
  }

  getAllMessages(id: string) {
    this.busy = this.messageService.getMessagesBySubmissionId(id).subscribe(
      (data) => {
        this.messages = data;
        this.message = new Message();

      },
      () => {

      },
      () => {
      }
    );
  }

  addMessage() {
    let msg = this.message;
    this.message = new Message();

    msg.submission = this.submission_id;
    msg.isauthor = 1;
    if (msg.content.trim() === '') {
      return;
    }
    msg.createdDate = new Date();
    msg.status = 1;
    this.messages.push(msg);


    this.messageService.sendMessage(msg).subscribe(
      (data) => {
        this.messages[this.messages.length - 1].status = 2;

      },
      () => {
        this.messages[this.messages.length - 1].status = -1;


      }
    );

  }

}
